import axios from './httpClient';

export function normalizeAgendaEvents(events = []) {
  const uniqueEvents = new Map();

  events.filter(Boolean).forEach((event) => {
    const start = event.start?.includes('T') ? event.start.split('T')[0] : event.start;
    const normalized = {
      ...event,
      ...(start ? { start } : {}),
      id: event.id || `${start || 'unknown'}-${event.title || 'event'}`,
    };
    const key = `${normalized.start}-${normalized.title}-${normalized.id}`;
    if (!uniqueEvents.has(key)) {
      uniqueEvents.set(key, normalized);
    }
  });

  return Array.from(uniqueEvents.values());
}

export function combineAgendaResults(results = []) {
  return normalizeAgendaEvents(results.flatMap((result) => (Array.isArray(result) ? result : [])));
}

function getToken(instance, accounts) {
  return instance
    .acquireTokenSilent({
      scopes: [
        'https://cortechapb2c.onmicrosoft.com/corte-chap-api/orders.read',
        'https://cortechapb2c.onmicrosoft.com/corte-chap-api/invoices.read',
      ],
      account: accounts[0],
    })
    .then((response) => response.accessToken);
}

function formatearKilosArg(valor) {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(valor);
}


export async function getAgenda(userID, instance, accounts, company) {

  const accessToken = await getToken(instance, accounts);
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Cache-Control': 'max-age=31536000',
    },
  };


  const agendaPedidos = axios
    .get(`${process.env.REACT_APP_API_URL}/shipments/?AccountID=${userID}&offset=0&limit=200`, config)
    // .get(`http://localhost:8080/v1/shipments/?AccountID=${userID}&StateCode=0`, config)
    .then((response) => {
      const rows = response.data.data.rows;

      const grouped = rows
        .filter(item => item.Statecode === 0 && item.ShipmentDate && item.ShipmentOrder)
        .reduce((acc, item) => {
          const key = `${item.ShipmentDate}__${item.ShipmentOrder.trim()}__${item.ShipmentGUID}`;

          if (!acc[key]) {
            acc[key] = {
              start: item.ShipmentDate,
              shipmentOrder: item.ShipmentOrder.trim(),
              totalQuantity: 0,
              backgroundColor: '#FF9636',
              borderColor: '#FF9636',
              shipmentItemGUID: item.ShipmentItemGUID // nuevo
            };
          }
          

          acc[key].totalQuantity += item.Quantity;
          return acc;
        }, {});

        return Object.values(grouped).map(event => ({
          id: event.shipmentItemGUID, // nuevo
          start: event.start,
          title: `${formatearKilosArg(event.totalQuantity)} KG - ${event.shipmentOrder}`,
          backgroundColor: event.backgroundColor,
          borderColor: event.borderColor,
        }));
        
        
    })
    .catch((error) => {
      console.log('Error en el calendario', error);
      return [];
    });


  const agendaEventos = axios
    .get(`${process.env.REACT_APP_API_URL}/utilities/events`, config)
    .then((response) =>
      response.data.data.map((row) => ({
        id: `event-${row.EventDate}-${row.Title}`,
        start: row.EventDate,
        title: row.Title,
        backgroundColor: 'white',
        borderColor: 'white',
      }))
    )
    .catch((error) => {
      console.log('el error del calendar', error);
      return [];
    });

  const fechaActual = new Date();
  const primerDiaDelMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
  const ultimoDiaDelMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);

  function formatearFecha(fecha) {
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    return `${año}/${mes}/${dia}`;
  }

  const primerDiaDelMesFormateado = formatearFecha(primerDiaDelMes);
  const ultimoDiaDelMesFormateado = formatearFecha(ultimoDiaDelMes);

  const agendaInvoices = axios
    .get(
      `${process.env.REACT_APP_API_URL}/invoices?CUSTNMBR=${userID}&Company=${company}&DueDate=${primerDiaDelMesFormateado}&DueDate2=${ultimoDiaDelMesFormateado}&offset=0&limit=200`,
      config
    )
    .then((response) =>
      response.data.data.rows.map((row) => ({
        id: `invoice-${row.DueDate}-${row.SOPNUMBE}`,
        start: row.DueDate,
        title: row.SOPNUMBE,
        backgroundColor: '#3CB9BD',
        borderColor: '#3CB9BD',
      }))
    )
    .catch((error) => {
      console.log('el error del calendar', error);
      return [];
    });

  return Promise.all([agendaPedidos, agendaEventos, agendaInvoices])
    .then(combineAgendaResults)
    .catch((error) => {
      console.log('el error del calendar', error);
    });
}

export async function getShipmentRecount(userID, instance, accounts, company) {
  const accessToken = await getToken(instance, accounts);
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Cache-Control': 'max-age=31536000',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_API_URL}/shipments/recount?AccountID=${userID}`, config)

    //.get(`http://localhost:8080/v1/shipments/recount?AccountID=${userID}`, config)
    .then((response) => response.data.data)
    .catch((error) => {
      throw error;
    });
}
